import anchorme from './dist/node/index.js';

export default anchorme.default;
export const {
	list,
	validate,
} = anchorme.default;
